module.exports = __webpack_public_path__ + "static/img/5836_phase_function_Paper_PointsHejduk_Prediction.4350d73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5836_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 1F7e
// module chunks = 0